export const paperSizes = [
  // {
  //   portrait: {
  //     widthInMM: 841,
  //     heightInMM: 1189,
  //     widthInPX: 3179,
  //     heightInPX: 4494,
  //   },
  //   landscape: {
  //     widthInMM: 1189,
  //     heightInMM: 841,
  //     widthInPX: 4494,
  //     heightInPX: 3179,
  //   },
  //   type: 'A',
  //   name: 'A0 Document',
  //   shortcut: 'A0',
  //   lowercaseName: 'a0',
  // },
  // {
  //   portrait: {
  //     widthInMM: 594,
  //     heightInMM: 841,
  //     widthInPX: 2245,
  //     heightInPX: 3179,
  //   },
  //   landscape: {
  //     widthInMM: 841,
  //     heightInMM: 594,
  //     widthInPX: 3179,
  //     heightInPX: 2245,
  //   },
  //   type: 'A',
  //   name: 'A1 Document',
  //   shortcut: 'A1',
  //   lowercaseName: 'a1',
  // },
  // {
  //   portrait: {
  //     widthInMM: 420,
  //     heightInMM: 594,
  //     widthInPX: 1587,
  //     heightInPX: 2245,
  //   },
  //   landscape: {
  //     widthInMM: 594,
  //     heightInMM: 420,
  //     widthInPX: 2245,
  //     heightInPX: 1587,
  //   },
  //   type: 'A',
  //   name: 'A2 Document',
  //   shortcut: 'A2',
  //   lowercaseName: 'a2',
  // },
  // {
  //   portrait: {
  //     widthInMM: 297,
  //     heightInMM: 420,
  //     widthInPX: 1123,
  //     heightInPX: 1587,
  //   },
  //   landscape: {
  //     widthInMM: 420,
  //     heightInMM: 297,
  //     widthInPX: 1587,
  //     heightInPX: 1123,
  //   },
  //   type: 'A',
  //   name: 'A3 Document',
  //   shortcut: 'A3',
  //   lowercaseName: 'a3',
  // },
  {
    portrait: {
      widthInMM: 210,
      heightInMM: 297,
      widthInPX: 794,
      heightInPX: 1123,
    },
    landscape: {
      widthInMM: 297,
      heightInMM: 210,
      widthInPX: 1123,
      heightInPX: 794,
    },
    type: 'A',
    name: 'A4 Document',
    shortcut: 'A4',
    lowercaseName: 'a4',
  },
  // {
  //   portrait: {
  //     widthInMM: 148,
  //     heightInMM: 210,
  //     widthInPX: 559,
  //     heightInPX: 794,
  //   },
  //   landscape: {
  //     widthInMM: 210,
  //     heightInMM: 148,
  //     widthInPX: 794,
  //     heightInPX: 559,
  //   },
  //   type: 'A',
  //   name: 'A5 Document',
  //   shortcut: 'A5',
  //   lowercaseName: 'a5',
  // },
  // {
  //   portrait: {
  //     widthInMM: 105,
  //     heightInMM: 148,
  //     widthInPX: 397,
  //     heightInPX: 559,
  //   },
  //   landscape: {
  //     widthInMM: 148,
  //     heightInMM: 105,
  //     widthInPX: 559,
  //     heightInPX: 397,
  //   },
  //   type: 'A',
  //   name: 'A6 Document',
  //   shortcut: 'A6',
  //   lowercaseName: 'a6',
  // },
  {
    portrait: {
      widthInMM: 215.9,
      heightInMM: 279.4,
      widthInPX: 816,
      heightInPX: 1056,
    },
    landscape: {
      widthInMM: 279.4,
      heightInMM: 215.9,
      widthInPX: 1056,
      heightInPX: 816,
    },
    type: 'us-letter',
    name: 'US Letter Document',
    shortcut: 'us-letter',
    lowercaseName: 'us_letter',
  },
  {
    portrait: {
      widthInMM: 215.9,
      heightInMM: 355.6,
      widthInPX: 816,
      heightInPX: 1344,
    },
    landscape: {
      widthInMM: 355.6,
      heightInMM: 215.9,
      widthInPX: 1344,
      heightInPX: 816,
    },
    type: 'us-legal',
    name: 'US Legal Document',
    shortcut: 'us-legal',
    lowercaseName: 'us_legal',
  },
  {
    type: 'custom',
    name: 'Custom Sizing',
    shortcut: 'custom',
    lowercaseName: 'custom',
  },
];
